import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
import { isEmpty } from "lodash";
import styles from "./Notification.module.scss";

const Notification = () => {
  const { success, error } = useSelector(state => ({
    success: state.notification.success,
    error: state.notification.error
  }));

  const dispatch = useDispatch();
  const [isHoveredOrFocused, setIsHoveredOrFocused] = useState(false);
  const timerRef = useRef(null);

  // Auto-dismiss logic with pause-on-interaction for accessibility
  useEffect(() => {
    if (!isEmpty(success) && !isHoveredOrFocused) {
      timerRef.current = setTimeout(() => {
        dispatch({ type: "RESET_SUCCESS_MSG" });
      }, 5000);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [success, isHoveredOrFocused, dispatch]);

  const handleClose = e => {
    const { option } = e.currentTarget.dataset;
    if (option === "success") {
      dispatch({ type: "RESET_SUCCESS_MSG" });
    }
    if (option === "error") {
      dispatch({ type: "RESET_ERROR_MSG" });
    }
  };

  return ReactDOM.createPortal(
    <div 
      className={styles.notification}
      onMouseEnter={() => setIsHoveredOrFocused(true)}
      onMouseLeave={() => setIsHoveredOrFocused(false)}
      onFocus={() => setIsHoveredOrFocused(true)}
      onBlur={() => setIsHoveredOrFocused(false)}
    >
      {/* SUCCESS NOTIFICATION */}
      {!isEmpty(success) && (
        <div 
          className={`${styles.container} ${styles.success}`}
          role="status" 
          aria-live="polite"
          aria-atomic="true"
        >
          <button
            className={`${styles.button} ${styles.successClose}`}
            type="button"
            data-option="success"
            onClick={handleClose}
            aria-label="Dismiss success message"
          >
            &#x2716;
          </button>
          <p className={styles.successMessageText}>{success.message}</p>
        </div>
      )}

      {/* ERROR NOTIFICATION */}
      {!isEmpty(error) && (
        <div 
          className={`${styles.container} ${styles.error}`}
          role="alert" 
          aria-live="assertive"
          aria-atomic="true"
        >
          <button
            className={`${styles.button} ${styles.errorClose}`}
            type="button"
            data-option="error"
            onClick={handleClose}
            aria-label="Dismiss error message"
          >
            &#x2716;
          </button>
          
          <div className={styles.errorContent}>
            <p className={styles.errorMessageText}>{error.message}</p>
            {!isEmpty(error.list) && (
              <ul className={styles.errorListContainer}>
                {error.list.map((err, index) => (
                  <li key={index} className={styles.errorList}>
                    {err}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>,
    document.body
  );
};

export default Notification;
